import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const ArrowRightIcon = (props: SvgIconProps): JSX.Element => {
  const { sx, ...otherProps } = props;
  return (
    <SvgIcon {...otherProps} viewBox="0 0 24 24" sx={{ color: 'inherit', ...sx }}>
      <path
        d="M16.172 11L10.808 5.63605L12.222 4.22205L20 12L12.222 19.778L10.808 18.364L16.172 13H4V11H16.172Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default ArrowRightIcon;
